import React, { useContext } from 'react';
import {
   Nav, Tab,
} from 'react-bootstrap';
import { NavItem, NavLink, TabsWrap } from '@/shared/components/Tabs';
// import Pending from './Pending';
// import Confirm from './Confirmed';
// import Past from './Past';
import { AuthContext } from '../../../../context/AuthContext';
import DataReactTable from './ONgoing/DataReactTable';
import PastTrip from './Past/DataReactTable';



const Tabs = () => {
  const { agentId } = useContext(AuthContext);
    
  return (
    <>
      {/* Tabs */}
      <Tab.Container defaultActiveKey="1" style={{ marginTop: '500px' }}>
        <TabsWrap>
          
          <Nav className="nav-tabs">
            <NavItem>
              <NavLink eventKey="1">Ongoing</NavLink>
            </NavItem>
            <NavItem>
              <NavLink eventKey="2">Past</NavLink>
            </NavItem>
          </Nav>
          <Tab.Content>
            <Tab.Pane eventKey="1">

              <DataReactTable />
            </Tab.Pane>
            <Tab.Pane eventKey="2">
              <PastTrip />
            </Tab.Pane>

          </Tab.Content>
        </TabsWrap>
      </Tab.Container>

     
    </>
  );
};

export default Tabs;
